/**
 * Real Photos - Photos réelles fournies par le client
 * Ces photos DOIVENT être utilisées à la place de toute image IA ou placeholder
 * 
 * IMPORTANT: Ne JAMAIS remplacer par des images générées par IA
 * Images converties de HEIC vers JPEG et stockées localement
 */

export const realPhotos = {
  // Spa extérieur avec palmiers, terrasse bois, ambiance tropicale premium
  // Usage idéal: Hero principal homepage
  heroMain: '/images/terrain/hero-final.jpg',
  
  // IMG_2001 - Spa sur deck bois avec gazon, ambiance sereine
  // Usage idéal: Page expertise/installation
  installation1: '/images/terrain/installation-1.jpg',
  
  // IMG_2393 - Spa sous pergola, terrasse carrelée, intimité
  // Usage idéal: Page catégorie spas
  spaCategory: '/images/terrain/spa-category.jpg',
  
  // IMG_2632 - Spa avec bambou et clôture bois, gazon artificiel, ambiance zen
  // Usage idéal: Section accompagnement/expertise
  expertise: '/images/terrain/expertise.jpg',
  
  // IMG_3699 - Jets actifs, jardin luxuriant avec palmier
  // Usage idéal: Section savoir-faire/qualité
  savoirFaire: '/images/terrain/savoir-faire.jpg',
  
  // Spa de nage sur terrasse bois en montagne
  // Usage idéal: Hero page spa de nage
  spaNageHero: '/images/terrain/spa-nage-hero.jpg',
  
  // Spa 2-3 places avec éclairage ambiant
  // Usage idéal: Hero page spas 2-3 places
  spa2_3PlacesHero: '/images/terrain/spa-2-3-places-hero.jpg',
};

// Descriptions pour les attributs alt
export const realPhotosAlt = {
  heroMain: 'Spa extérieur sur terrasse en bois avec palmier et jardin tropical verdoyant',
  installation1: 'Installation de spa sur terrasse en bois avec jardin verdoyant',
  spaCategory: 'Spa encastré sous pergola sur terrasse carrelée effet bois',
  expertise: 'Spa avec écran de bambou et clôture bois, ambiance zen et intimité',
  savoirFaire: 'Jets de spa en fonctionnement dans un jardin luxuriant avec palmier',
  spaNageHero: 'Spa de nage moderne installé sur terrasse bois avec vue montagne et forêt',
  spa2_3PlacesHero: 'Spa compact 2-3 places avec éclairage LED ambiant sur terrasse',
};

export default realPhotos;
